function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import ButtonWrapper from '../button-wrapper';
import { size8, size144, CONTROL_SIZE_MAP } from '../../theme/scale';
import Icon from '../../icon';
export const Wrapper = styled(ButtonWrapper)`
  align-items: center;
  border-radius: ${size144};
  display: inline-flex;
  justify-content: center;
  min-width: ${size144};
  position: relative;
  ${({
  fullWidth
}) => fullWidth && 'width: 100%;'}
  ${({
  size
}) => size && {
  ...CONTROL_SIZE_MAP[size]
}}
`;
const ButtonIcon = styled(Icon)`
  ${({
  $endIcon
}) => $endIcon && `margin-left: ${size8};`}
  ${({
  $startIcon
}) => $startIcon && `margin-right: ${size8};`}
`;
export const Button = ({
  children,
  startIcon,
  endIcon,
  disabled = false,
  loading = false,
  variant = 'base',
  outlineIcon = false,
  size = 'md',
  element = 'button',
  fullWidth = false,
  id,
  onClick,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, props, {
    forwardedAs: element,
    onClick,
    size,
    disabled,
    loading,
    variant,
    fullWidth,
    id
  }), startIcon && /*#__PURE__*/React.createElement(ButtonIcon, {
    $startIcon: !!startIcon,
    outlined: outlineIcon,
    decorative: true,
    type: startIcon,
    size: 18
  }), children, endIcon && /*#__PURE__*/React.createElement(ButtonIcon, {
    $endIcon: !!endIcon,
    outlined: outlineIcon,
    decorative: true,
    type: endIcon,
    size: 18
  }));
};
export default Button;
//# sourceMappingURL=index.js.map